// Network Configuration - Change USE_MAINNET to switch networks
export const USE_MAINNET = true;

export const NETWORKS = {
  MAINNET: {
    chainId: '0x38',
    chainIdDecimal: 56,
    chainName: 'BNB Smart Chain',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: ['https://bsc-dataseed1.binance.org'],
    blockExplorerUrls: ['https://bscscan.com']
  },
  TESTNET: {
    chainId: '0x61',
    chainIdDecimal: 97,
    chainName: 'BNB Smart Chain Testnet',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545'],
    blockExplorerUrls: ['https://testnet.bscscan.com']
  }
};

export const CURRENT_NETWORK = USE_MAINNET ? NETWORKS.MAINNET : NETWORKS.TESTNET;

export const getExplorerUrl = (hash, type = 'tx') => {
  return `${CURRENT_NETWORK.blockExplorerUrls[0]}/${type}/${hash}`;
};
